import { useMemo } from "react";
import { getJwtRoleSlug } from "../../../public/utils/jwtRole";
import { getStoredAuthRole } from "../../../public/utils/authSession";
import { getAuthItem } from "../../../public/utils/authStorage";
import { useMembershipRolePermissions } from "../hooks/useMembershipRolePermissions";
import {
  buildMembershipPermissions,
  buildMembershipPermissionsForScreen,
} from "./membershipPermissions";

function resolveRoleSlug() {
  return (
    getJwtRoleSlug(getAuthItem("jwt_token")) ||
    getStoredAuthRole() ||
    ""
  );
}

/**
 * Staff membership permissions for a screen slug.
 * Do not use on student portal pages (my-memberships).
 */
export function useMembershipRole(screenSlug = null) {
  const sessionRoleSlug = useMemo(() => resolveRoleSlug(), []);

  const {
    permissions,
    roleSlug: apiRoleSlug,
    isUnrestricted,
    loading: permLoading,
    error: permissionsError,
  } = useMembershipRolePermissions(Boolean(sessionRoleSlug));

  const roleSlug = apiRoleSlug || sessionRoleSlug;

  const perms = useMemo(() => {
    const opts = { isUnrestricted };
    if (screenSlug) {
      return buildMembershipPermissionsForScreen(
        permissions,
        roleSlug,
        screenSlug,
        opts,
      );
    }
    return buildMembershipPermissions(permissions, roleSlug, opts);
  }, [permissions, roleSlug, isUnrestricted, screenSlug]);

  return {
    roleSlug,
    permissionsLoading: permLoading,
    permissionsError,
    isAdmin: perms.isAdmin,
    canView: perms.canView,
    canCreate: perms.canCreate,
    canEdit: perms.canEdit,
    canDelete: perms.canDelete,
    canManageMasters: perms.canManageMasters,
    canDeleteMasters: perms.canDeleteMasters,
    canExport: perms.canExport,
  };
}
